import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const app = new modular({
    modules: modules
});

// on dom ready set scroll top to 0 0
document.addEventListener('DOMContentLoaded', function () {
    init();
    classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-wrapper').getAttribute('data-namespace'))
    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;
    if(window.isMobile) {
        html.classList.add('is-mobile');
    }
    // goToAnchor();
});

// on load set the dom to loaded
window.addEventListener('load', function () {
    this.setTimeout(() => {
        goToAnchor();
    },300);
});

function init() {
    globals();
    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');
        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });
    }, 50);
    
    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('dom-is-loaded');
        html.classList.remove('is-loading');
    }, 300);

    // output the focus element when the user use tab key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            // get element with current focus
            let focused = document.activeElement;
            // console.log(focused);
        }
    });

    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 2000);

    function setDocHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
		let element = document.querySelector('.c-programmes-search');
		if (element) {
			let height = element.offsetHeight;
			document.documentElement.style.setProperty('--c-programmes-search-height', `${height}px`);
		}
    };
    window.addEventListener('resize', function () {
        setDocHeight();
    });
    window.addEventListener('orientationchange', function () {
        setDocHeight();
    });
    setDocHeight();
}

function goToAnchor() {
    let anchor = window.location.hash;
    if (!anchor) return;
    let el = document.querySelector(anchor);
    if (el) {
        let newTop = el.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({
            top: newTop,
            behavior: 'instant'
        })
        if (newTop > 100){
            html.classList.add('is-scrolling-down');
            html.classList.add('has-header-fixed');
        }
        window.dispatchEvent(new Event('resize'));
    }
}